import { _ as _defineProperty, a as _slicedToArray } from '../_chunks/dep-50ece1d9.js';
import { u as useApiProps, _ as _toConsumableArray } from '../_chunks/dep-f0ef67c3.js';
import { _ as _objectWithoutProperties } from '../_chunks/dep-06688d2c.js';
import React, { forwardRef, useState, useEffect, useCallback } from 'react';
import '../util/use-size-props.js';
import '../util/use-common-classname.js';
import '../util/use-config.js';

var _excluded = ["colors", "className", "id", "hover", "size", "disabled", "style", "color", "onMouseEnter", "onMouseLeave"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var HelpCircleIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$colors = props.colors,
    colors = _props$colors === void 0 ? [] : _props$colors,
    className = props.className,
    _props$id = props.id,
    id = _props$id === void 0 ? "" : _props$id,
    _props$hover = props.hover,
    hover = _props$hover === void 0 ? "" : _props$hover,
    size = props.size,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    style = props.style,
    color = props.color,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    resultProps = _objectWithoutProperties(props, _excluded);
  var _useApiProps = useApiProps({
      className: className,
      initColor: ["currentColor", "white"],
      initName: "help-circle",
      colors: colors,
      id: id,
      hover: hover,
      size: size,
      style: style,
      disabled: disabled,
      color: color
    }),
    sizeStyle = _useApiProps.sizeStyle,
    cls = _useApiProps.cls;
  var _useState = useState(["currentColor", "white"]),
    _useState2 = _slicedToArray(_useState, 2),
    colorList = _useState2[0],
    setColorList = _useState2[1];
  var _useState3 = useState(["currentColor", "white"]),
    _useState4 = _slicedToArray(_useState3, 2),
    colorsProps = _useState4[0],
    setColorsProps = _useState4[1];
  var _useState5 = useState(["currentColor", "white"]),
    _useState6 = _slicedToArray(_useState5, 2),
    defaultColor = _useState6[0],
    _ = _useState6[1];
  useEffect(function () {
    if (typeof colors === "string" && "help-circle".indexOf("-colored") === -1) {
      var col = JSON.parse(JSON.stringify(["currentColor", "white"]));
      var find = col.find(function (item) {
        return item === "currentColor";
      });
      var _col = col;
      if (find) {
        _col = col.map(function (item) {
          if (item === "currentColor") {
            item = colors;
          }
          return item;
        });
      } else {
        _col[0] = colors;
      }
      setColorList(_col);
      setColorsProps(_col);
    }
    if (colors instanceof Array && "help-circle".indexOf("-colored") === -1) {
      var colorList1 = JSON.parse(JSON.stringify(["currentColor", "white"]));
      colors.forEach(function (col) {
        var findColorIndex = colorList1.findIndex(function (v) {
          return v === col.targetColor;
        });
        if (findColorIndex >= 0) {
          colorList1[findColorIndex] = col.reviseColor;
        }
      });
      setColorList(_toConsumableArray(colorList1));
      setColorsProps(_toConsumableArray(colorList1));
    }
    if (color && typeof color === "string" && "help-circle".indexOf("-colored") === -1) {
      var _col2 = JSON.parse(JSON.stringify(["currentColor", "white"]));
      var _find = _col2.find(function (item) {
        return item === "currentColor";
      });
      var _col3 = _col2;
      if (_find) {
        _col3 = _col2.map(function (item) {
          if (item === "currentColor") {
            item = color;
          }
          return item;
        });
      } else {
        _col3[0] = color;
      }
      setColorList(_col3);
      setColorsProps(_col3);
    }
  }, [JSON.stringify(colors), color, defaultColor]);
  var handleMouseEnter = useCallback(function (event) {
    onMouseEnter && onMouseEnter(event);
    if (!hover || hover.length === 0) return;
    if (colors instanceof Array && "help-circle".indexOf("-colored") === -1) {
      if (hover instanceof Array && "help-circle".indexOf("-colored") === -1) {
        var colorList1 = JSON.parse(JSON.stringify(colorList));
        hover.forEach(function (col) {
          var findColorIndex = colorList1.findIndex(function (v) {
            return v === col.targetColor;
          });
          if (findColorIndex >= 0) {
            colorList1[findColorIndex] = col.reviseColor;
          }
        });
        setColorList(_toConsumableArray(colorList1));
      }
    }
    if (typeof colors === "string" && "help-circle".indexOf("-colored") === -1) {
      if (typeof hover === "string") {
        var col = JSON.parse(JSON.stringify(colorList));
        var find = col.find(function (item) {
          return item === colors;
        });
        var _col = col;
        if (find) {
          _col = col.map(function (item) {
            if (item === colors) {
              item = hover;
            }
            return item;
          });
        } else {
          _col[0] = hover;
        }
        setColorList(_col);
      }
    }
    if (color && typeof color === "string" && "help-circle".indexOf("-colored") === -1) {
      if (typeof hover === "string") {
        var _col4 = JSON.parse(JSON.stringify(colorList));
        var _find2 = _col4.find(function (item) {
          return item === color;
        });
        var _col5 = _col4;
        if (_find2) {
          _col5 = _col4.map(function (item) {
            if (item === color) {
              item = hover;
            }
            return item;
          });
        } else {
          _col5[0] = hover;
        }
        setColorList(_col5);
      }
    }
    if (!color && colors.length === 0 && typeof hover === "string" && "help-circle".indexOf("-colored") === -1) {
      var _col6 = JSON.parse(JSON.stringify(colorList));
      var _find3 = _col6.find(function (item) {
        return item === "currentColor";
      });
      var _col7 = _col6;
      if (_find3) {
        _col7 = _col6.map(function (item) {
          if (item === "currentColor") {
            item = hover;
          }
          return item;
        });
      } else {
        _col7[0] = hover;
      }
      setColorList(_col7);
    }
    if (!color && colors.length === 0 && hover instanceof Array && "help-circle".indexOf("-colored") === -1) {
      var _colorList = JSON.parse(JSON.stringify(colorList));
      hover.forEach(function (col) {
        var findColorIndex = _colorList.findIndex(function (v) {
          return v === col.targetColor;
        });
        if (findColorIndex >= 0) {
          _colorList[findColorIndex] = col.reviseColor;
        }
      });
      setColorList(_toConsumableArray(_colorList));
    }
  }, [colorList, defaultColor, colors, color, hover]);
  var handleMouseLeave = useCallback(function (event) {
    onMouseLeave && onMouseLeave(event);
    if (!hover || hover.length === 0) return;
    var _defaultColor = JSON.parse(JSON.stringify(defaultColor));
    if (colorsProps) {
      _defaultColor = JSON.parse(JSON.stringify(colorsProps));
    }
    setColorList(_defaultColor);
  }, [colorsProps, defaultColor, hover]);
  return /* @__PURE__ */React.createElement("svg", _objectSpread(_objectSpread({
    id: "help-circle",
    style: sizeStyle,
    className: cls,
    ref: ref,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, resultProps), {}, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }), /* @__PURE__ */React.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */React.createElement("g", {
    clipPath: "url(#clip0_19498_556)"
  }, /* @__PURE__ */React.createElement("path", {
    d: "M7.33317 12.336H8.66911V11.0001H7.33317V12.336Z",
    fill: colorList[0],
    fillOpacity: "0.9"
  }), /* @__PURE__ */React.createElement("path", {
    d: "M6.6665 6.17859C6.6665 5.5772 7.21189 5 7.99984 5C8.78778 5 9.33317 5.5772 9.33317 6.17859C9.33317 6.47495 9.20887 6.75355 8.9871 6.96958L7.33317 8.35553V10H8.6665V8.97781L9.8761 7.9642L9.89079 7.9503C10.3631 7.50307 10.6665 6.87821 10.6665 6.17859C10.6665 4.74176 9.42103 3.66667 7.99984 3.66667C6.57864 3.66667 5.33317 4.74176 5.33317 6.17859V6.84525H6.6665V6.17859Z",
    fill: colorList[0],
    fillOpacity: "0.9"
  }), /* @__PURE__ */React.createElement("path", {
    d: "M7.99984 15.3334C12.0499 15.3334 15.3332 12.0502 15.3332 8.00008C15.3332 3.94999 12.0499 0.666748 7.99984 0.666748C3.94975 0.666748 0.666504 3.94999 0.666504 8.00008C0.666504 12.0502 3.94975 15.3334 7.99984 15.3334ZM13.9998 8.00008C13.9998 11.3138 11.3135 14.0001 7.99984 14.0001C4.68613 14.0001 1.99984 11.3138 1.99984 8.00008C1.99984 4.68637 4.68613 2.00008 7.99984 2.00008C11.3135 2.00008 13.9998 4.68637 13.9998 8.00008Z",
    fill: colorList[0],
    fillRule: "evenodd",
    clipRule: "evenodd",
    fillOpacity: "0.9"
  })), /* @__PURE__ */React.createElement("defs", null, /* @__PURE__ */React.createElement("clipPath", {
    id: "clip0_19498_556"
  }, /* @__PURE__ */React.createElement("rect", {
    width: "16",
    height: "16",
    fill: colorList[1]
  })))));
});
HelpCircleIcon.displayName = "HelpCircleIcon";

export { HelpCircleIcon as default };
//# sourceMappingURL=help-circle.js.map
